import React from 'react';

export function RatingsDivider() {
    const starIcon = (
        <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7831 6.05444C15.8176 5.98258 15.8756 5.98186 15.913 6.05228L19.229 12.3166C19.2664 12.3863 19.3618 12.4517 19.4418 12.4618L26.5918 13.3384C26.6718 13.3484 26.6908 13.4023 26.6343 13.4584L21.5749 18.4825C21.5184 18.5385 21.4846 18.6485 21.4993 18.7261L22.8575 25.6551C22.8729 25.7334 22.826 25.7679 22.7541 25.7319L16.3114 22.5725C16.2388 22.5373 16.1221 22.5394 16.0517 22.5775L9.7411 25.9842C9.67065 26.0222 9.62222 25.9892 9.6347 25.9116L10.7119 18.9345C10.7244 18.8561 10.6855 18.7484 10.6268 18.6945L5.36846 13.8701C5.30976 13.8155 5.32663 13.7609 5.40662 13.748L12.5155 12.5961C12.5948 12.5832 12.688 12.5135 12.7225 12.4424L15.7831 6.05444Z"
                fill="white"
                stroke="white"
                strokeWidth="2"
            />
        </svg>
    );

    const rating = (rating: string, text: React.ReactNode, icon?: React.ReactNode) => (
        <div className="col-4 flex justify-center">
            <div className="flex align-items-center flex-column flex-md-row">
                <h1 className="rating flex align-items-center pb-0  mcl-font-greycliff">
                    {rating}
                    {icon && icon}
                </h1>
                <span className="rating-text mcl-font-proxima pl-0">{text}</span>
            </div>
        </div>
    );

    return (
        <section className="ratings-divider py-4 px-0">
            <div className="googlelp-container text-center flex justify-content-evenly align-items-center px-2">
                {rating(
                    '1 Million',
                    <span>
                        Treatments per <br className="mobile-break" /> year
                    </span>
                )}
                {rating(
                    '4.94',
                    <span>
                        Google <br className="mobile-break" /> Rating
                    </span>,
                    starIcon
                )}
                {rating(
                    '400',
                    <span>
                        Locations <br className="mobile-break" /> nationwide
                    </span>,
                    <p className="ratings-divider-plus mb-0">+</p>
                )}
            </div>
        </section>
    );
}

export default RatingsDivider;
